import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";

import { Box } from "@mui/material";

import {TABS_DATA} from "../../constants";
import {useModal, useTableSearch, useTabSearchParams} from "../../hooks";

import PersonRowData from "./components/PersonRowData";
import {
    AppModal,
    PageHeader,
    PageWrapper,
    TableForms,
    TableHeader,
    TabList,
    TabTable
} from "../../components";
import useItem from "../../services/item/itemService";
import PersonForm from "./components/PersonForm";
import {prepareDataToBackendFormat} from "../../utils/helpers";
import useTags from "../../services/tags/tagsService";

export default function PersonPage(){
    const styles = {
        tabList:{
            width: '100%',
            height: '48px',
            typography: 'body1',
            borderBottom: 1,
            borderColor: '#E7E4E4',
            paddingTop: '1rem'
        },
        tableWrapper: {
            maxHeight: '30vh',
            height: '30vh',
        }
    }

    const {id} = useParams();

    const person = useSelector(state => state.item.selectedItem);
    const personLastUpdated = useSelector(state => state.item.lastUpdated);
    const isLoading = useSelector(state => state.tags.isLoading);

    const {tab, setTab} = useTabSearchParams(TABS_DATA.personTabs);

    const { getItemDataById, resetItem, updateItemData } = useItem("/persons");
    const {searchValue, setSearchValue} = useTableSearch();
    const [open, handleOpen, handleClose] = useModal();
    const [getTagsData, resetTagsState] = useTags("/person");

    const onVisualizeClick = (e) => {
        e.preventDefault()
        window.open(`${process.env.REACT_APP_PUBLIC_VISUALIZE}?id=${id}&type=Person`, '_blank')
    }

    const onEditSubmit = (values) => updateItemData({id: person?.id, data: prepareDataToBackendFormat(values)});

    useEffect(()=>{
        if(id){
            getItemDataById({id})
        }
    }, [id, personLastUpdated])

    useEffect(()=>{
        if(searchValue) {
            setSearchValue("")
        }
    }, [tab])

    useEffect(()=>{
        if(open === "edit") {
            getTagsData();
        }
    }, [open])

    useEffect(()=>()=> {
        resetItem()
        resetTagsState()
    }, []);

    return(
        <PageWrapper>
            <PageHeader onEdit={(e)=>handleOpen(e, "edit")} onVisualize={onVisualizeClick} title='Person' {...person}/>
            <PersonRowData {...person}/>
            <Box
                component="div"
                sx={styles.tabList}
            >
                <TabList tabs={TABS_DATA.personTabs} tab={tab} setTab={setTab}/>
            </Box>
            <TableHeader value={searchValue} onChange={setSearchValue} onClick={(e)=>handleOpen(e, tab)}/>
            {
                TABS_DATA.personTabs.map(({table, value}) => (
                        tab === value && (
                                <TabTable
                                    key={`${value}-tab-panel-item`}
                                    tab={tab} table={table} value={value}
                                    url={`/persons/${id}`}
                                    sx={styles.tableWrapper}
                                />
                        ))
                )
            }
            <AppModal
                handleClose={handleClose}
                open={(!!person?.id && !!open)}
                title={open === "edit" ? "modal.edit.person" : `modal.${open}`}
            >
                {open === "edit" && (
                    <PersonForm
                        isLoading={!!isLoading}
                        {...person}
                        onSubmitForm={onEditSubmit}
                        onCancel={handleClose}/>
                )}
                {open && open !== "edit" && <TableForms id={person?.id} form={open} onCancel={handleClose} path="/persons"/>}
            </AppModal>
        </PageWrapper>
    )
}